import CardApplyLayout from '@sunbit-dev/ui/src/components/card-apply/layouts/cardApplyLayout/CardApplyLayout';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectUrlPath } from '../selectors';
import GoogleTagManagerService from '../services/analytics/GoogleTagManagerService.js';

const pathToStep = {
  '/application': 1,
  '/application/approval-terms': 2,
  '/application/payment-details': 3,
  '/application/thanks': 4,
};

const numberOfSteps = 3;

const CardApplyLayoutContainer: React.FC = (props) => {
  const urlPath = useSelector(selectUrlPath) as keyof typeof pathToStep;
  GoogleTagManagerService.eventPageView(urlPath);
  const currentStep = pathToStep[urlPath];
  const showProgress = currentStep === undefined ? false : true;

  return (
    <CardApplyLayout numberOfSteps={numberOfSteps} currentStep={currentStep} showProgress={showProgress}>
      {props.children}
    </CardApplyLayout>
  );
};

export default CardApplyLayoutContainer;
